module.exports = __webpack_public_path__ + "static/img/index_image02.9e1e90ba.png";